import {styled} from '@mui/material'

export const HeaderSummaryCardStyle = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '18px 0px'
}))
